import axios from 'axios';

const backendModule = {
  namespaced: true,
  state: {
    b2b: window.ACC?.isB2Bsite,
    accountConsumerToggleAccess: window.ACC?.accountConsumerToggleAccess ?? true,
    consumerFriendlyMode: window.ACC?.accountConsumerToggleAccess ? window.ACC?.isB2BPriceToggle : true,
    cartToggle: window.ACC?.cartToggle ?? false,
    isAdmin: window.ACC?.isAdmin ?? false,
    contextPath: window.ACC?.config?.contextPath ?? '',
    encodedContextPath: window.ACC?.config?.encodedContextPath ?? '',
    isB2BPurchasable: window.ACC?.isB2BPurchasable ?? false,
    appleLabelAccess: window.ACC?.appleLabelAccess,
    maxCartItems: window.ACC?.maxCartItems ?? 950,
    textCheckoutB2BTooManyItems: window.ACC?.textCheckoutB2BTooManyItems ?? '',
    isDistributor: window.ACC?.isDistributor ?? false,
    isDropShipFlagEnabled: window.ACC?.isDropShipFlagEnabled ?? false,
    containerToDelete: null,
    isSpectrumEnabled: false,
    isUserLoggedIn: window.ACC?.isUserLoggedIn,
  },

  getters: {
    b2b(state) {
      return state.b2b;
    },
    cartToggle(state) {
      return state.cartToggle;
    },
    consumerFriendlyMode(state) {
      return state.consumerFriendlyMode;
    },
  },

  mutations: {
    setB2b(state, value) {
      state.b2b = value;
    },
    setCartToggle(state, value) {
      state.cartToggle = value;
    },
    setConsumerFriendlyMode(state, value) {
      state.consumerFriendlyMode = value;
    },
    setContainerToDelete(state, value) {
      state.containerToDelete = value;
    },
    setIsSpectrumEnabled(state, value) {
      state.isSpectrumEnabled = value;
    },
  },

  actions: {
    toggleConsumerFriendlyMode({commit, state}) {
      let value = !state.consumerFriendlyMode;

      axios
        .get(`/my-account/price-toggle?priceToggle=${value}`)
        .then(() => {
          commit('setConsumerFriendlyMode', value);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

export default backendModule;
